module.exports = __webpack_public_path__ + "img/thumbnail_RedRuffedLemur_j_normal.dd203152.png";